<template>
  <Modal :is-open="isOpen" :footer-class="loading ? 'hidden' : ''" @modal:confirm="altaMedioPago"
    @modal:cancel="onCancel" class="z-10 flex items-center justify-center" container-class="max-h-full rounded-lg">
    <Cargando v-if="loading" mensaje="Guardando datos..." class="px-4 py-2 md:p-6" />
    <div v-else class="overflow-y-auto px-4 py-2 sm:flex sm:items-start md:p-6">
      <div
        class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-yellow-100 sm:mx-0 sm:h-10 sm:w-10">
        <SolidExclamationIcon class="h-6 w-6 text-yellow-500" />
      </div>

      <div class="mt-3 space-y-4 text-center sm:ml-4 sm:mt-0 sm:text-left">
        <h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-title">
          Se habilitará el pago mediante {{ medioPago.descripcion }} para el comprobante
          seleccionado.
        </h3>

        <MessageCard v-if="['MBP', 'PNET'].includes(medioPago?.id.trim())" type="info" message=""
          class="divide-x divide-blue-200">
          <div class="space-y-1 pl-4">
            <p class="block text-justify">
              Para finalizar el proceso de pago, será redirigido al sitio de
              {{ medioPago?.id.trim() === 'MBP' ? 'Macro Pago' : 'Provincia NET' }}.
            </p>
            <p class="block text-justify">
              El estado del comprobante permanecerá EN PROCESO o PAGO A REGISTRAR hasta tanto
              recibamos la notificación de pago por parte de
              {{ medioPago?.id.trim() === 'MBP' ? 'Macro' : 'Provincia NET' }}
              y el mismo sea registrado.
            </p>
          </div>
        </MessageCard>

        <div class="space-y-1">
          <p class="text-base text-gray-900">¿Desea dar de alta el medio de pago?</p>
          <p v-if="error" class="text-sm font-medium text-red-500">
            {{ error }}
          </p>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import MessageCard from '@/components/Core/MessageCard'
import { useService } from '@colescba/app-vue'
import { useSession } from '@colescba/ui'

import Cargando from '@/components/Core/Cargando.vue'

export default {
  props: {
    medioPago: { type: Object, required: true },
    deuda: { type: Object, required: true },
    isOpen: { type: Boolean, required: true },
  },

  mixins: [useSession(), useService('portalPagos')],

  components: {
    Cargando,
    MessageCard,
  },

  data() {
    return {
      loading: false,
      error: null,
    }
  },

  watch: {
    isOpen(newValue, oldValue) {
      if (newValue) {
        document.querySelector('body').classList.add('overflow-y-hidden')
      } else {
        document.querySelector('body').classList.remove('overflow-y-hidden')
      }
    },
  },

  methods: {
    async altaMedioPago() {
      this.loading = true
      this.error = null

      try {
        await this.portalPagos.putDeuda(this.user.cuitCuil.numero, this.deuda.id, {
          medios_pago: [this.medioPago.id],
        })

        const medio = this.medioPago.id.trim()

        if (medio === 'MBP') {
          const html = await this.portalPagos.getHtmlMacroClick(
            this.user.cuitCuil.numero,
            this.deuda.id,
          )
          const blob = new Blob([html], { type: 'text/html' })
          const url = URL.createObjectURL(blob)
          window.location.href = url
        } else if (medio === 'PNET') {
          console.log('Generando pago en ProvinciaNet...')
          const result = await this.portalPagos.createProvinciaNetPayment(
            this.user.cuitCuil.numero,
            this.deuda.id,
          )

          const redirectUrl =
            typeof result === 'string' ? result : result?.redirectUrl || result?.url || null

          if (redirectUrl) {
            console.log('Redirigiendo a ProvinciaNet...', redirectUrl)
            window.open(redirectUrl, '_blank')
          } else {
            console.log('Respuesta de ProvinciaNet (sin URL):', result)
          }
        } else {
          console.log('Ocurrió un error al dar de alta el medio de pago o medio no soportado.')
        }

        this.$emit('modal:confirm')
      } catch (error) {
        if (error.response && error.response.status === 422) {
          try {
            const responseData = JSON.parse(error.response.data.errors[0])
            this.error = responseData.errors[0]
          } catch (e) {
            this.error = 'Error al procesar la respuesta del servidor.'
          }
        } else {
          this.error = 'Ocurrió un error al dar de alta el medio de pago.'
        }
      } finally {
        this.loading = false
      }
    },

    onCancel() {
      this.error = null
      this.$emit('modal:cancel')
    },
  },

  beforeDestroy() {
    document.querySelector('body').classList.remove('overflow-y-hidden')
  },
}
</script>
